import React, { Component } from "react";
import style from "./PercentageBar.module.scss";

// Taken from https://www.vandelaydesign.com/progress-bar-design/ and https://codepen.io/WhiteWolfWizard/pen/izhHd

class PercentageBar extends Component {
  render() {
    return (
      <section className={style.progress}>
        <aside
          style={{
            width: Math.round(this.props.currentPercentage) + "%",
            backgroundColor: this.props.barColor,
          }}
          className={style.bar}
        ></aside>
        <aside style={{ left: Math.round(this.props.fixedMarkerPercentage) + "%" }} className={style.divider}>
          <span>{this.props.fixedMarkerText}</span>
        </aside>
      </section>
    );
  }
}

export default PercentageBar;
